<template>
  <div>
    <div class="mt-6 flex-row just-between">
      <div>
        <div class="flex-row align-center">
          <div class="sac__font-30 semi-bold">
            Unit {{ (hvac.indexOf(hvac.find((x)=>x === selectedUnit))) + 1 }}: {{ selectedUnit.manufacturer }}
          </div>
          <div class="zone ml-4">
            Zone: {{ selectedUnit.zone }}
          </div>
        </div>
        <div class="sac__font-16 med n60">
          {{ serviceAddress }}
        </div>
      </div>
      <div class="flex-row align-center">
        <button
          type="button"
          @click="showPrint"
        >
          <div class="virtual-visit-record-btn">
            <div class="sac__font-20 f-white semibold icon-luc-Printer" />
          </div>
        </button>
        <button
          v-if="adminRole !== 'viewer' && providerPlan?.planType === 'Hardware'"
          type="button"
          class="ml-2"
          @click="showVirtualVisitPdf"
        >
          <div class="virtual-visit-record-btn">
            <div class="sac__font-16 f-white semibold">View Guide</div>
          </div>
        </button>
        <button
          v-if="adminRole !== 'viewer' && providerPlan?.planType === 'Hardware'"
          class="ml-2"
          type="button"
          @click="launchVirtualVisit"
        >
          <div class="virtual-visit-record-btn">
            <img
              src="@shared/assets/img/general/record-video-icon.svg"
              class="record-camera-icon"
              alt="Virtual Visit"
            />
            <div class="sac__font-16 f-white semibold ml-4">
              Record a New Virtual Visit
            </div>
          </div>
        </button>
      </div>
    </div>
    <div class="system-card grid-column even gap-150 margin-top-16">
      <div class="card-col">
        <div class="grid-column ai-c jc-b">
          <div class="sac__font-16 med">System Age</div>
          <div class="sac__font-16 n60">{{ selectedUnit.systemAge }} yr</div>
        </div>
        <div class="grid-column ai-c jc-b">
          <div class="sac__font-16 med">System Type</div>
          <div class="sac__font-16 n60">
            {{ selectedUnit.systemType }} System
          </div>
        </div>
        <div class="grid-column ai-c jc-b">
          <div class="sac__font-16 med">Manufacture</div>
          <div class="sac__font-16 n60">
            {{ selectedUnit.manufacturer }}
          </div>
        </div>
      </div>
      <div class="card-col">
        <div class="grid-column ai-c jc-b">
          <div class="sac__font-16 med">Model</div>
          <div class="sac__font-16 n60">
            {{ selectedUnit.model }}
          </div>
        </div>
        <div class="grid-column ai-c jc-b">
          <div class="sac__font-16 med">Type/Speed</div>
          <div class="sac__font-16 n60">
            {{ selectedUnit.type ?? '--' }}/{{ selectedUnit.speed }}
          </div>
        </div>
        <div class="grid-column ai-c jc-b">
          <div class="sac__font-16 med">SEER</div>
          <div class="sac__font-16 n60">
            {{ selectedUnit.seer }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import customerDetailMixin from '@shared/mixins/customerDetailMixin';

export default {
  name: 'SystemDetail',
  mixins: [customerDetailMixin],
  computed: {
    ...mapState({
      selectedUnit: (state) => state.customerDetail.selectedUnit,
    }),
    serviceAddress() {
      const { serviceAddress } = this.selectedUnit;
      if (!serviceAddress) {
        return '--';
      }
      return serviceAddress.address1;
    },
  },
  methods: {
    launchVirtualVisit() {
      this.toggleActionModal(true, 'launch-visit');
    },
    showPrint() {
      window.print();
    },
    showVirtualVisitPdf() {
      window.open('https://smac-images.s3.us-west-2.amazonaws.com/email/virtual-visit-info.pdf', '_blank');
    },
  },
};
</script>

<style scoped lang="scss">
.system-card {
  background-color: $N5;
  border-radius: 8px;
  display: grid;
  padding: 2rem 4rem;
}
.card-col {
  display: grid;
  gap: 1rem;
}
.zone {
  background-color: $N10;
  color: $N60;
  font-weight: 600;
  font-size: 16px;
  padding: 2px 10px;
  border-radius: 900px;
}
.virtual-visit-record-btn {
  display: flex;
  flex-direction: row;
  background-color: #4471f1;
  padding: 7px 14px;
  align-items: center;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  margin: 12px 0;
}
</style>
